import { createFileRoute, useNavigate } from '@tanstack/react-router';

import { TutorClassListTemplate } from '@/features/tutor-ai';

export const Route = createFileRoute('/_authenticated/tutor-ai/classes/')({
  component: TutorClassListPage,
});

/** Página da listagem de turmas do tutor. */
export function TutorClassListPage() {
  const navigate = useNavigate();

  return (
    <TutorClassListTemplate
      onOpenClass={item =>
        void navigate({
          to: '/tutor-ai/classes/$classStudentId',
          params: { classStudentId: String(item.classStudentId) },
          search: { label: item.label },
        })
      }
    />
  );
}
